"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customProps = require("../../../../utils/customProps");

var _customComponents = require("../../../../utils/customComponents");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _Grid = _interopRequireDefault(require("../../../../components/PageGrid/templates/Grid/Grid"));

var _GridItem = _interopRequireDefault(require("../../../../components/PageGrid/templates/GridItem/GridItem"));

var _AppBarOffset = _interopRequireDefault(require("./components/AppBarOffset/AppBarOffset"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// atoms
var Image = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/atoms/Image/Image"));
  });
}); // molecules

var Typography = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/Typography/Typography"));
  });
});
var ButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/ButtonRedirect/ButtonRedirect"));
  });
});
var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
}); // templates

var ButtonDrawer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/templates/ButtonDrawer/ButtonDrawer"));
  });
});
var IconButtonDrawer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/templates/IconButtonDrawer/IconButtonDrawer"));
  });
});
var components = {
  Image: Image,
  Typography: Typography,
  ButtonRedirect: ButtonRedirect,
  IconButtonRedirect: IconButtonRedirect,
  ButtonDrawer: ButtonDrawer,
  IconButtonDrawer: IconButtonDrawer,
  AppBarGridItem: _GridItem.default
};

var AppBar = function AppBar(_ref) {
  var rootClass = _ref.rootClass,
      color = _ref.color,
      position = _ref.position,
      content = _ref.content,
      variant = _ref.variant,
      disableGutters = _ref.disableGutters,
      height = _ref.height,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    height: height
  });

  var grid = content[0];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    color: color,
    position: position,
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    variant: variant,
    disableGutters: disableGutters
  }, (0, _customComponents.renderComponentsWithBridge)({
    AppBarGrid: _Grid.default
  }, _objectSpread(_objectSpread({}, grid), {}, {
    components: components
  })))), position === 'fixed' && /*#__PURE__*/_react.default.createElement(_AppBarOffset.default, null));
};

var _default = AppBar;
exports.default = _default;
AppBar.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Override or extend the styles applied to the component.
  */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: 'default', 'inherit', 'primary', 'secondary', 'transparent'
   * AppBar: The color of the component. It supports those theme colors that make sense for this component.
   * */
  color: function color(props, propName, componentName) {
    var validProp = ['default', 'inherit', 'primary', 'secondary', 'transparent'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * 'absolute', 'fixed', 'relative', 'static' , 'sticky'
   * AppBar: The positioning type. The behavior of the different options is described in the MDN web docs.
   * Note: sticky is not universally supported and will fall back to static when unavailable.
   * */
  position: function position(props, propName, componentName) {
    var validProp = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: 'regular', 'dense'
   * ToolBar: The variant to use.
   *  */
  variant: function variant(props, propName, componentName) {
    var validProp = ['regular', 'dense'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: true | false
   * Toolbar: If true, disables gutter padding.
   * */
  disableGutters: _propTypes.default.bool,

  /**
   * Height of the App Bar must use 'px', 'em', '%' 'vh', 'vw', as unit of measurement
   * */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Content passed to AppBar to render
   */
  content: function content(props, propName, componentName) {
    var validComponents = ['AppBarGrid'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, validComponents, 1);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
AppBar.defaultProps = {
  color: 'primary',
  height: '60px',
  position: 'fixed',
  variant: 'regular',
  disableGutters: false,
  rootClass: [],
  content: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};